import styled from 'styled-components'

export const StyledErrorModal = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 200;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: ${({ theme }) =>
        theme.colours.background.transparent_black};
`

export const StyledError = styled.div`
    width: calc(100% - 64px);
    max-width: 280px;
    background-color: #ffffff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    padding: 20px 16px;
    font-size: 14px;
`

export const StyledErrorIcon = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
`

export const StyledErrorTitle = styled.h3`
    margin: 0 0 16px 0;
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
    text-align: center;
`

export const StyledErrorContent = styled.div`
    text-align: center;
    color: #4a4a4a;
    line-height: 1.6;
    font-size: 14px;
    margin-bottom: 24px;

    strong {
        color: #1a1a1a;
        display: block;
        margin-bottom: 12px;
        font-size: 14px;
        font-weight: 600;
    }

    ul {
        text-align: left;
        margin: 12px auto 0 auto;
        padding-left: 24px;
        font-size: 13px;
        max-width: 320px;
    }

    li {
        margin: 8px 0;
        color: #4a4a4a;
    }
`

export const StyledErrorActions = styled.div`
    display: flex;
    width: 100%;
`

export const StyledClose = styled.button`
    width: 100%;
    height: 40px;
    background: #dc3545;
    border: none;
    border-radius: 6px;
    color: #ffffff;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    -webkit-transition: all 0.15s ease;
    -o-transition: all 0.15s ease;
    transition: all 0.15s ease;

    &:hover {
        background: #c82333;
    }

    &:active {
        transform: translateY(1px);
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.25);
    }
`
